// extracted by mini-css-extract-plugin
export default {"review-address":"LeftColumn_review-address__a+9Ow","galleryImage":"LeftColumn_galleryImage__TYxG6"};